module.exports = __webpack_public_path__ + "static/media/Vector.0339a93c.svg";